import BooleanType from './BooleanType';
export default BooleanType;
